module.exports = __webpack_public_path__ + "img/gb13871-92-30x47x7.prt.0ba9978d.jpg";